<template>
  <div>
    <div class="pb-8 pr-6 items-center w-full" v-if="isQueueRunning">
      <div class="flex items-center justify-between bg-green-500 rounded">
        <div class="flex items-center">
          <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><polygon points="0 11 2 9 7 14 18 3 20 5 7 18" /></svg>
          <div class="py-4 text-white font-medium">Queue jobs are running. So, the site will not load any content please wait till the jobs are completed.</div>
        </div>
      </div>
    </div>
    <Head title="Import Profiles" />
    <h1 class="mb-8 text-3xl font-bold">Import Profiles</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/import-profiles/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Import Profile</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Title</th>
            <th class="pb-4 pt-6 px-6">Connector</th>
            <th class="pb-4 pt-6 px-6">Scheduled</th>
            <th class="pb-4 pt-6 px-6">Profile Type</th>
            <th class="pb-4 pt-6 px-6">Status</th>
            <th class="pb-4 pt-6 px-6"></th>
            <th class="pb-4 pt-6 px-6"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="importProfile in importProfiles.data" :key="importProfile.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/import-profiles/${importProfile.id}/edit`">
                {{ importProfile.title }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/import-profiles/${importProfile.id}/edit`">
                {{ importProfile.connector.title }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/import-profiles/${importProfile.id}/edit`">
                {{ importProfile.scheduled_task }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/import-profiles/${importProfile.id}/edit`">
                {{ importProfile.profile_type }}
              </Link>
            </td>
            <td class="border-t">
              <div class="flex">
                <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/import-profiles/${importProfile.id}/edit`">
                  {{ importProfile.status }}
                </Link>
              </div>
            </td>
            <td class="w-px border-t">
              <button class="btn-indigo mb-1 mt-1 ml-3 mr-3" v-if="importProfile.status == 'Pending' || importProfile.status == 'Finished'" @click="addToQueue(importProfile.id, importProfile.hasFiles)">Add To Queue</button>
              <div v-if="!isQueueRunning || isQueueRunningId != importProfile.id">
                <button class="btn-indigo w-36 mb-1 mt-1 ml-3 mr-3" v-if="!(importProfile.status == 'Pending' || importProfile.status == 'Finished')" @click="runQueue(importProfile.id)">Run Queue</button>
              </div>
              <LoadingBar class="h-16 justify-center ml-12 items-center" v-if="!(importProfile.status == 'Pending' || importProfile.status == 'Finished') && isQueueRunning && isQueueRunningId == importProfile.id" />
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/import-profiles/${importProfile.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="importProfiles.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="7">No Profile found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="importProfiles.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import axios from 'axios'
import LoadingBar from '@/Shared/LoadingBar'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    LoadingBar
  },
  layout: Layout,
  props: {
    filters: Object,
    importProfiles: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      isQueueRunning: false,
      isQueueRunningId: 0,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/import-profiles', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    addToQueue(profileId, hasFiles) {
      if (hasFiles) {
        axios
          .post('/import-profiles/add-to-queue', {
            id: profileId,
          })
          .then(function (response) {
            window.location.reload()
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        alert('Files not Exists.')
      }
    },

    runQueue(profileId) {
      let that = this
      that.isQueueRunning = true
      that.isQueueRunningId = profileId
      axios
        .post('/import-profiles/run-queue', {
          id: profileId,
        })
        .then(function (response) {
          that.isQueueRunning = false
          window.location.reload()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
  },
}
</script>
